<template>
<div class="box">
    <div class="ct_service">
        <div @click="dialogVisible = true"><img src="@/assets/images/ctSve.png" alt=""></div>

        <el-popover
            placement="left"
            :title="null"
            width="200"
            trigger="hover"
        >
            <div slot="reference">
                <img src="@/assets/images/ico.png" alt="">
            </div>
            <div class="content_code">
                <img src="../assets/images/CXcode.png" alt="">
            </div>
        </el-popover>
        
    </div>
    <template v-if="dialogVisible">
        <el-dialog
                :visible.sync="dialogVisible"
                width="610px"
            >
            <span slot="title" class="dialog-footer">
                <img src="@/assets/images/cttitleImg.png" alt="">
                <span>彩讯5G消息客服</span>
            </span>
            <div class="content_box">
                <ul>
                    <li class="input_box">
                        <p class="labe">请选择您要申请试用的产品类型（可多选）</p>
                        <ul class="sel_btn">
                            <li :class="{'selIdsty':selListId.includes(item.id)}" @click="selBtn(index,item.id)" v-for="(item,index) in selList" :key="item.id">{{item.name}}</li>
                        </ul>
                    </li>
                    <li class="input_box">
                        <p class="labe">手机:</p>
                        <el-input v-model="ph" placeholder="请输入内容"></el-input>
                    </li>
                    <li class="input_box">
                        <p class="labe">邮箱:</p>
                        <el-input v-model="elm"  placeholder="请输入内容"></el-input>
                    </li>
                    <li class="input_box">
                        <p class="labe">公司名称:</p>
                        <el-input v-model="name" placeholder="请输入内容"></el-input>
                    </li>
                    <li class="input_box">
                        <p class="labe">需求说明:</p>
                        <el-input v-model="demand" type="textarea"  placeholder="请输入内容"></el-input>
                    </li>
                </ul>
                <div class="btn_box">
                    <span class="btn" @click="toapply">
                        申请试用
                    </span>
                </div>
            </div>
        </el-dialog>
    </template>
</div>
</template>

<script>
export default {
    data(){
        return{
            dialogVisible: false,
            selList:[
                {
                    id:1,
                    name:'5G消息',
                },
                {
                    id:2,
                    name:'视频短信',
                },
                {
                    id:3,
                    name:'短信',
                }
            ],
            selListId:[],
            ph:"",
            elm:"",
            name:"",
            demand:"",
        }
    },
    mounted(){
        // this.toapply();
    },
    methods:{
        selBtn(index,id){
            if(!this.selListId.includes(id)){
                this.selListId.push(id);
            }else{
                this.selListId.splice(this.selListId.indexOf(id),1);
            }
            console.log(this.selListId);
        },
        toapply(){
             //手机正则
            let ph = /^1[3456789]\d{9}$/;
            let emz = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+((\.[a-zA-Z0-9_-]+)*)+\.(com|cn)$/;
            // console.log(this.ph,this.elm,this.name,this.demand,this.selListId.length);
            if(!this.ph || !this.elm || !this.name || !this.demand || !this.selListId.length ) return this.$message.warning('请完整填写信息后提交');
            if(!ph.test(this.ph)) {
                this.ph = '';
                this.$message.warning('请输入正确的11位手机号');
                return
            } 
            if(!emz.test(this.elm)){
                this.elm = '';
                this.$message.warning('请输入正确的邮箱号');
                return
                
            }
            let names = [];
            this.selList.forEach(item=>{
                if(this.selListId.includes(item.id)){
                    names.push(item.name)
                }
            })
            
            let content = '';
            content = `试用产品：${names.join(',')}
                手机号：${this.ph}
                邮箱地址：${this.elm}
                需求说明：${this.demand}
            `

            // console.log(names,content);

            this.sendRequest('/microx-user/userMessageRecord/notice/saveTryOut',{
                messageType: "APPLYTRY",
                noticeContent: content,
                noticeName: this.name
            }).then(res=>{
                console.log(res);
                if(res.returnCode == 0){
                    this.$message.success('已成功提交申请');
                    this.dialogVisible = false;
                    this.ph = '';
                    this.elm = '';
                    this.name = '';
                    this.demand = '';
                    this.selListId = [];
                }
            })
        },
    }
}
</script>

<style scoped>
.ct_service{
    position: fixed;
    top: 50%;
    right: 10px;
    z-index: 999;
    background-color: #fff;
    box-shadow: 0 0 5px #999;
}
.ct_service div{
    padding: 10px;
    cursor: pointer;
}
.dialog-footer img{
    vertical-align: middle;
    margin-right: 15px;
}
.dialog-footer span{
    font-size: 18px;
    color: #3A4654;
}
.box /deep/ .el-dialog__body{
    padding: 0;
}
.content_box{
    background-color: #f5f7f9;
    padding: 30px 45px;
}
.content_box .labe{
    font-size: 14px;
    color: #3A4654;
    margin-bottom: 10px;
}
.content_box .sel_btn {
    display: flex;
    justify-content:space-between;
}
.content_box .sel_btn .selIdsty{
    background-color: #1791FF;
    color: #fff;
}
.content_box .sel_btn li{
    display: inline-block;
    width: 160px;
    height: 48px;
    background-color: #fff;
    border-radius: 5px;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
}
.input_box{
    margin-top: 25px;
}
.btn_box{
    text-align: center;
    margin-top: 40px;
}
.btn_box .btn{
    display: inline-block;
    width: 200px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    background-color: #3A4654;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
}

.content_code img{
    width: 100%;
    /* height: 200px; */
    object-fit: contain;
}
</style>


// WEBPACK FOOTER //
// src/components/ctServich.vue